import React, { PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useProfile } from '@/auth/signin/datacontroller/AuthContext';
import { PATH, getRedirectPath } from '@/main/controller/MainController';

const CheckAuthComp: React.FC<PropsWithChildren> = ({ children }) => {
  const { profile } = useProfile();
  const pathname = window.location.pathname;

  if (
    pathname === PATH.ROOT ||
    pathname === PATH.TERM_ONBOARDING ||
    pathname === PATH.TERM_PAYMENT ||
    pathname === PATH.TERM_PRIVACY ||
    pathname === PATH.JOIN_FROM_PLATFORM
  ) {
    return <Outlet />;
  }

  const redirectPath = getRedirectPath(window.location);

  return profile ? <Navigate to={redirectPath || PATH.MAIN} replace /> : <Outlet />;
};

export default CheckAuthComp;
